// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"241":"62fcdf50","476":"3825e29e","644":"62fcdf50","997":"02a386a4"}[chunkId] + ".chunk.css";
};